import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    paper: {
        boxShadow: theme.shadows[8]
    },
    addButton: {
        borderRadius: 0
    }
}));